import { Component, Input, inject } from '@angular/core';
import { restockAlertConfig } from '../../../../core/config/restock-alert.config';
import { AuthService } from '../../../../shared';
import { Router } from '@angular/router';
import { BuyerService, GaService, ProductService } from '../../../../services';

@Component({
  selector: 'app-my-navigation',
  templateUrl: './my-navigation.component.html',
  styleUrls: ['./my-navigation.component.scss'],
  standalone: false,
})
export class MyNavigationComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private gaService = inject(GaService);
  private productService = inject(ProductService);
  private buyerService = inject(BuyerService);

  @Input() currentPage: string;

  get isRestockAlertUiEnabled(): boolean {
    return restockAlertConfig.enabled && this.buyerService.canUseRestockAlert;
  }

  signout() {
    this.authService.signout();
    this.productService.selectProducts = [];
    this.gaService.logLogout();
    this.router.navigate(['/signin']);
  }
}
